import { render, staticRenderFns } from "./PdfViewerUi.vue?vue&type=template&id=448318b4&scoped=true"
import script from "./PdfViewerUi.vue?vue&type=script&lang=js"
export * from "./PdfViewerUi.vue?vue&type=script&lang=js"
import style0 from "./PdfViewerUi.vue?vue&type=style&index=0&id=448318b4&prod&scoped=true&lang=scss"
import style1 from "./PdfViewerUi.vue?vue&type=style&index=1&id=448318b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448318b4",
  null
  
)

export default component.exports